module.exports = __webpack_public_path__ + "static/media/intro-photowall-23.1fadd222.jpg";